import * as tslib_1 from "tslib";
import * as React from 'react';
import { observer } from 'mobx-react';
import { Dialog, DialogFooter, DialogType } from 'office-ui-fabric-react/lib/Dialog';
import { Spinner, SpinnerSize } from 'office-ui-fabric-react/lib/Spinner';
import { PrimaryButton, DefaultButton } from 'office-ui-fabric-react/lib/Button';
import { ChoiceGroup } from 'office-ui-fabric-react/lib/ChoiceGroup';
import { connectedAccountsStore } from '../store/store';
import { ConnectionType } from '../store/schema/ConnectionType';
import { updateAdvancedConnectionType } from '../actions/connectAdvanced/updateAdvancedConnectionType';
import { updateAdvancedIsConnecting } from '../actions/connectAdvanced/updateAdvancedIsConnecting';
import { updateAdvancedImapServer } from '../actions/connectAdvanced/updateAdvancedImapServer';
import { updateAdvancedPopServer } from '../actions/connectAdvanced/updateAdvancedPopServer';
import { updateAdvancedIncomingPort } from '../actions/connectAdvanced/updateAdvancedIncomingPort';
import { updateAdvancedLeaveCopy } from '../actions/connectAdvanced/updateAdvancedLeaveCopy';
import { updateAdvancedRemoteSend } from '../actions/connectAdvanced/updateAdvancedRemoteSend';
import { updateAdvancedOutgoingServer } from '../actions/connectAdvanced/updateAdvancedOutgoingServer';
import { updateAdvancedOutgoingPort } from '../actions/connectAdvanced/updateAdvancedOutgoingPort';
import { updateAdvancedUseAltUsernamePassword } from '../actions/connectAdvanced/updateAdvancedUseAltUsernamePassword';
import { updateAdvancedAltUsername } from '../actions/connectAdvanced/updateAdvancedAltUsername';
import { updateAdvancedAltPassword } from '../actions/connectAdvanced/updateAdvancedAltPassword';
import { updateAdvancedDisplayName } from '../actions/connectAdvanced/updateAdvancedDisplayName';
import { updateAdvancedEmailAddress } from '../actions/connectAdvanced/updateAdvancedEmailAddress';
import { updateAdvancedUserName } from '../actions/connectAdvanced/updateAdvancedUserName';
import { updateAdvancedPassword } from '../actions/connectAdvanced/updateAdvancedPassword';
import { updateAdvancedUseNewFolder } from '../actions/connectAdvanced/updateAdvancedUseNewFolder';
import { updateAdvancedIncomingSecurity } from '../actions/connectAdvanced/updateAdvancedIncomingSecurity';
import { updateAdvancedIncomingAuth } from '../actions/connectAdvanced/updateAdvancedIncomingAuth';
import { toggleConnectAdvancedWindow } from '../actions/connectAdvanced/toggleConnectAdvancedWindow';
import { newSyncRequest } from '../services/newSyncRequest';
import { initConnectedAccountsFull } from '../orchestrators/initConnectedAccountsFull';
import strings from 'owa-strings/owa-options-strings';
import IncomingAccountInformation from './IncomingAccountInformation';
import IncomingServerInformation from './IncomingServerInformation';
import OutgoingServerInformation from './OutgoingServerInformation';
import { getConnectAdvancedSyncRequest } from '../selectors/getConnectAdvancedSyncRequest';
import { getErrorConnectAdvanced } from '../selectors/getErrorConnectAdvanced';
var styles = require('./ConnectAdvancedWindow.scss');
var ConnectAdvancedWindow = /** @class */ (function (_super) {
    tslib_1.__extends(ConnectAdvancedWindow, _super);
    function ConnectAdvancedWindow() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onClose = function () {
            toggleConnectAdvancedWindow({ connectAdvancedOpen: false });
        };
        _this.onConnect = function () {
            updateAdvancedIsConnecting(true);
            newSyncRequest(getConnectAdvancedSyncRequest()).then(function (response) {
                updateAdvancedIsConnecting(false);
                toggleConnectAdvancedWindow({ connectAdvancedOpen: false });
                if (!response.ErrorMessage) {
                    initConnectedAccountsFull();
                }
            });
        };
        _this.onConnectionTypeChanged = function (option, evt) {
            if (option.key === 'ImapSmtp') {
                updateAdvancedConnectionType(ConnectionType.ImapSmtp);
            }
            else if (option.key === 'PopSmtp') {
                updateAdvancedConnectionType(ConnectionType.PopSmtp);
            }
            else if (option.key === 'SmtpOnly') {
                updateAdvancedConnectionType(ConnectionType.SmtpOnly);
            }
        };
        return _this;
    }
    ConnectAdvancedWindow.prototype.render = function () {
        var store = connectedAccountsStore();
        return (React.createElement(Dialog, { hidden: !store.dialogWindowState.connectAdvancedOpen, dialogContentProps: {
                type: DialogType.normal,
                title: strings.options_connected_advanced_title,
            }, modalProps: {
                isBlocking: true,
                containerClassName: styles.dialog,
                onDismiss: this.onClose,
            } },
            React.createElement(IncomingAccountInformation, { displayName: store.connectAdvancedState.displayName, emailAddress: store.connectAdvancedState.emailAddress, username: store.connectAdvancedState.username, password: store.connectAdvancedState.password, useNewFolder: store.connectAdvancedState.useNewFolder, disableEmailAddress: false, renderUserNameContent: true, renderNewFolderContent: true, isBasicAuth: true, onUpdateDisplayName: updateAdvancedDisplayName, onUpdateEmailAddress: updateAdvancedEmailAddress, onUpdateUserName: updateAdvancedUserName, onUpdatePassword: updateAdvancedPassword, onUpdateUseNewFolder: updateAdvancedUseNewFolder }),
            React.createElement(ChoiceGroup, { options: [
                    {
                        key: 'ImapSmtp',
                        text: strings.options_connected_advanced_imapOption,
                        checked: store.connectAdvancedState.connectionType ===
                            ConnectionType.ImapSmtp,
                    },
                    {
                        key: 'PopSmtp',
                        text: strings.options_connected_advanced_popOption,
                        checked: store.connectAdvancedState.connectionType ===
                            ConnectionType.PopSmtp,
                    },
                    {
                        key: 'SmtpOnly',
                        text: strings.options_connected_advanced_sendOnlyOption,
                        checked: store.connectAdvancedState.connectionType ===
                            ConnectionType.SmtpOnly,
                    },
                ], className: styles.options, required: true, label: strings.options_connected_advanced_connectionTypeOptionLabel, onChanged: this.onConnectionTypeChanged }),
            store.connectAdvancedState.connectionType !== ConnectionType.SmtpOnly && (React.createElement(IncomingServerInformation, { isBasicAuth: true, connectionType: store.connectAdvancedState.connectionType, renderRemoteSend: true, remoteSend: store.connectAdvancedState.remoteSend, incomingPort: store.connectAdvancedState.incomingPort, leaveCopy: store.connectAdvancedState.leaveCopy, leaveCopyDisabled: false, basicAuthProps: {
                    connectionType: store.connectAdvancedState.connectionType,
                    incomingAuth: store.connectAdvancedState.incomingAuth,
                    incomingSecurity: store.connectAdvancedState.incomingSecurity,
                    onUpdateIncomingAuth: updateAdvancedIncomingAuth,
                    onUpdateIncomingSecurity: updateAdvancedIncomingSecurity,
                }, onUpdateIncomingServer: store.connectAdvancedState.connectionType === ConnectionType.PopSmtp
                    ? updateAdvancedPopServer
                    : updateAdvancedImapServer, onUpdateIncomingPort: updateAdvancedIncomingPort, onUpdateLeaveCopy: updateAdvancedLeaveCopy, onUpdateRemoteSend: updateAdvancedRemoteSend })),
            React.createElement(OutgoingServerInformation, { isBasicAuth: true, outgoingPort: store.connectAdvancedState.outgoingPort, onUpdateOutgoingServer: updateAdvancedOutgoingServer, onUpdateOutgoingPort: updateAdvancedOutgoingPort, isSendOnly: function () {
                    return store.connectAdvancedState.connectionType === ConnectionType.SmtpOnly;
                }, isRemoteSend: function () { return store.connectAdvancedState.remoteSend; }, smtpAccountInformationProps: {
                    useAltUserNamePassword: function () {
                        return store.connectAdvancedState.useAltUsernamePassword;
                    },
                    onUpdateUseAltUserNamePassword: updateAdvancedUseAltUsernamePassword,
                    onUpdateSmtpUserName: updateAdvancedAltUsername,
                    onUpdateSmtpPassword: updateAdvancedAltPassword,
                } }),
            React.createElement(DialogFooter, null,
                store.connectAdvancedState.isConnecting && (React.createElement(Spinner, { size: SpinnerSize.large, className: styles.spinner })),
                React.createElement(PrimaryButton, { onClick: this.onConnect, disabled: getErrorConnectAdvanced() || store.connectAdvancedState.isConnecting }, strings.options_connected_okButton),
                React.createElement(DefaultButton, { onClick: this.onClose, disabled: store.connectAdvancedState.isConnecting }, strings.options_connected_cancelButton))));
    };
    ConnectAdvancedWindow = tslib_1.__decorate([
        observer
    ], ConnectAdvancedWindow);
    return ConnectAdvancedWindow;
}(React.Component));
export default ConnectAdvancedWindow;
//# sourceMappingURL=ConnectAdvancedWindow.js.map